import { render } from "./nav-bar-btns.vue?vue&type=template&id=62ce8a58"
import script from "./nav-bar-btns.vue?vue&type=script&lang=js"
export * from "./nav-bar-btns.vue?vue&type=script&lang=js"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__